import { render, staticRenderFns } from "./SpellButton.vue?vue&type=template&id=0df0d392"
import script from "./SpellButton.vue?vue&type=script&lang=js"
export * from "./SpellButton.vue?vue&type=script&lang=js"
import style0 from "./SpellButton.vue?vue&type=style&index=0&id=0df0d392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports